import { render, staticRenderFns } from "./ModalTermService.vue?vue&type=template&id=80744d7c&"
import script from "./ModalTermService.vue?vue&type=script&lang=js&"
export * from "./ModalTermService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports